import { render } from "./MaterialTabForPo.vue?vue&type=template&id=ca60a4b6&scoped=true"
import script from "./MaterialTabForPo.vue?vue&type=script&lang=js"
export * from "./MaterialTabForPo.vue?vue&type=script&lang=js"

import "./MaterialTabForPo.vue?vue&type=style&index=0&id=ca60a4b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca60a4b6"]])

export default __exports__